import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=8d01f7dc&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=js&"
export * from "./orderList.vue?vue&type=script&lang=js&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=8d01f7dc&scoped=true&lang=less&"
import style1 from "./orderList.vue?vue&type=style&index=1&lang=css&"
import style2 from "./orderList.vue?vue&type=style&index=2&id=8d01f7dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d01f7dc",
  null
  
)

export default component.exports